[
  {
    "id": "504",
    "name": "Sneakers",
    "description": "A little flimsy... but fashionable!",
    "defense": 1,
    "immunity": 0,
    "obtain": "Purchased from Adventurer's Guild after Initiation quest; Special Item drops Floors 1-39 of The Mines; Fishing Treasure Chests",
    "sellPrice": 50,
    "image": "images/footwear/Sneakers.png"
  },
  {
    "id": "505",
    "name": "Rubber Boots",
    "description": "Protection from the elements.",
    "defense": 0,
    "immunity": 1,
    "obtain": "Special Item drops Floors 1-39 of The Mines; Fishing Treasure Chests",
    "sellPrice": 50,
    "image": "images/footwear/Rubber Boots.png"
  },
  {
    "id": "506",
    "name": "Leather Boots",
    "description": "The leather is very supple.",
    "defense": 1,
    "immunity": 1,
    "obtain": "Reward from Chest Floor 10 of The Mines; Purchased from Adventurer's Guild after Floor 10; Fishing Treasure Chests",
    "sellPrice": 100,
    "image": "images/footwear/Leather Boots.png"
  },
  {
    "id": "507",
    "name": "Work Boots",
    "description": "Steel-toed for extra protection.",
    "defense": 2,
    "immunity": 0,
    "obtain": "Purchased from Adventurer's Guild after Floor 10; Possible Remixed Reward Floor 10; Fishing Treasure Chests",
    "sellPrice": 100,
    "image": "images/footwear/Work Boots.png"
  },
  {
    "id": "508",
    "name": "Combat Boots",
    "description": "Reinforced with iron mesh.",
    "defense": 3,
    "immunity": 0,
    "obtain": "Purchased from Adventurer's Guild after Floor 40; Possible Remixed Reward Floor 50; Special Item drops Floors 61-79; Fishing Treasure Chests",
    "sellPrice": 150,
    "image": "images/footwear/Combat Boots.png"
  },
  {
    "id": "509",
    "name": "Tundra Boots",
    "description": "The fuzzy lining keeps your ankles so warm.",
    "defense": 2,
    "immunity": 1,
    "obtain": "Reward from Chest Floor 50 of The Mines; Purchased from Adventurer's Guild after Floor 50; Fishing Treasure Chests",
    "sellPrice": 150,
    "image": "images/footwear/Tundra Boots.png"
  },
  {
    "id": "806",
    "name": "Leprechaun Shoes",
    "description": "The buckle's made of solid gold.",
    "defense": 2,
    "immunity": 1,
    "obtain": "Found on Trains",
    "sellPrice": 150,
    "image": "images/footwear/Leprechaun Shoes.png"
  },
  {
    "id": "510",
    "name": "Thermal Boots",
    "description": "Designed with extreme weather in mind.",
    "defense": 1,
    "immunity": 2,
    "obtain": "Possible Remixed Reward Floor 50; Special Item drops Floors 41-79; Fishing Treasure Chests",
    "sellPrice": 150,
    "image": "images/footwear/Thermal Boots.png"
  },
  {
    "id": "515",
    "name": "Cowboy Boots",
    "description": "It's the height of country fashion.",
    "defense": 2,
    "immunity": 2,
    "obtain": "Unobtainable",
    "sellPrice": 200,
    "image": "images/footwear/Cowboy Boots.png"
  },
  {
    "id": "511",
    "name": "Dark Boots",
    "description": "Made from thick black leather.",
    "defense": 4,
    "immunity": 2,
    "obtain": "Purchased from Adventurer's Guild after Floor 80; Possible Remixed Reward Floor 80; Special Item drops Floors 81-119, Skull Cavern, Quarry Mine; Fishing Treasure Chests",
    "sellPrice": 300,
    "image": "images/footwear/Dark Boots.png"
  },
  {
    "id": "512",
    "name": "Firewalker Boots",
    "description": "It's said these can withstand the hottest magma.",
    "defense": 3,
    "immunity": 3,
    "obtain": "Reward from Chest Floor 80 of The Mines; Purchased from Adventurer's Guild after Floor 80; Fishing Treasure Chests",
    "sellPrice": 300,
    "image": "images/footwear/Firewalker Boots.png"
  },
  {
    "id": "513",
    "name": "Genie Shoes",
    "description": "A curious energy permeates the fabric.",
    "defense": 1,
    "immunity": 6,
    "obtain": "Special Item drops Floors 81-119, Skull Cavern, Quarry Mine; Fishing Treasure Chests",
    "sellPrice": 350,
    "image": "images/footwear/Genie Shoes.png"
  },
  {
    "id": "514",
    "name": "Space Boots",
    "description": "An iridium weave gives them a purple sheen.",
    "defense": 4,
    "immunity": 4,
    "obtain": "Reward from Chest Floor 110 of The Mines; Purchased from Adventurer's Guild after Floor 110",
    "sellPrice": 400,
    "image": "images/footwear/Space Boots.png"
  },
  {
    "id": "878",
    "name": "Crystal Shoes",
    "description": "These sparkling shoes will keep your feet very safe.",
    "defense": 3,
    "immunity": 5,
    "obtain": "Possible Remixed Reward Floor 110; Special Item drops in Skull Cavern and Quarry Mine",
    "sellPrice": 400,
    "image": "images/footwear/Crystal Shoes.png"
  },
  {
    "id": "804",
    "name": "Emily's Magic Boots",
    "description": "Made with love by Emily. 100% compostable!",
    "defense": 4,
    "immunity": 4,
    "obtain": "Received during Emily's 14-heart event",
    "sellPrice": 400,
    "image": "images/footwear/Emily's Magic Boots.png"
  },
  {
    "id": "853",
    "name": "Cinderclown Shoes",
    "description": "These magic shoes belonged to a famous Dwarvish jester.",
    "defense": 6,
    "immunity": 5,
    "obtain": "Volcano Dungeon Shop (100 Cinder Shards)",
    "sellPrice": 550,
    "image": "images/footwear/Cinderclown Shoes.png"
  },
  {
    "id": "854",
    "name": "Mermaid Boots",
    "description": "Mermaid scales give these boots a protective aura.",
    "defense": 5,
    "immunity": 8,
    "obtain": "From a Rare Chest in the Volcano Dungeon",
    "sellPrice": 650,
    "image": "images/footwear/Mermaid Boots.png"
  },
  {
    "id": "855",
    "name": "Dragonscale Boots",
    "description": "These shimmering boots are extremely tough.",
    "defense": 7,
    "immunity": 0,
    "obtain": "From a Rare Chest in the Volcano Dungeon",
    "sellPrice": 350,
    "image": "images/footwear/Dragonscale Boots.png"
  }
]
